export async function sortOrderChangeFilterHelper({
  sortOrderValue,
  fileTypeFilter,
  validationStatusTypeFilter,
  filterSearchField,
  importStatusTypeFilter,
  uploadedDateFilter,
  importedDateFilter,
  sortColumnFilter,
  filesPerPage,
  setSortOrderFilter,
  setNoSearchResults,
  setFilesRetrieved,
  setTotalNumberOfRows,
  setFilterLoading,
  filterFiles,
  getLocalDateString,
}) {
  setSortOrderFilter(sortOrderValue);

  const { transformedData: _filesRetrieved, totalNumberOfRows: _totalNumberOfRows } =
    await filterFiles(
      fileTypeFilter,
      validationStatusTypeFilter,
      filterSearchField,
      importStatusTypeFilter,
      uploadedDateFilter ? getLocalDateString(uploadedDateFilter) : null,
      importedDateFilter ? getLocalDateString(importedDateFilter) : null,
      sortOrderValue,
      sortColumnFilter,
      filesPerPage,
      1,
    );

  if (!_filesRetrieved || _filesRetrieved.length === 0) {
    setNoSearchResults(true);
    setFilterLoading(false);

    return;
  }

  setNoSearchResults(false);
  setFilesRetrieved(_filesRetrieved);
  setTotalNumberOfRows(_totalNumberOfRows);
  setFilterLoading(false);
}

export async function sortColumnChangeFilterHelper({
  sortColumn,
  fileTypeFilter,
  validationStatusTypeFilter,
  filterSearchField,
  importStatusTypeFilter,
  uploadedDateFilter,
  importedDateFilter,
  sortOrderFilter,
  filesPerPage,
  setSortColumnFilter,
  setNoSearchResults,
  setFilesRetrieved,
  setTotalNumberOfRows,
  setFilterLoading,
  filterFiles,
  getLocalDateString,
}) {
  setSortColumnFilter(sortColumn);

  const { transformedData: _filesRetrieved, totalNumberOfRows: _totalNumberOfRows } =
    await filterFiles(
      fileTypeFilter,
      validationStatusTypeFilter,
      filterSearchField,
      importStatusTypeFilter,
      uploadedDateFilter ? getLocalDateString(uploadedDateFilter) : null,
      importedDateFilter ? getLocalDateString(importedDateFilter) : null,
      sortOrderFilter,
      sortColumn,
      filesPerPage,
      1,
    );

  if (!_filesRetrieved || _filesRetrieved.length === 0) {
    setNoSearchResults(true);
    setFilterLoading(false);

    return;
  }

  setNoSearchResults(false);
  setFilesRetrieved(_filesRetrieved);
  setTotalNumberOfRows(_totalNumberOfRows);
  setFilterLoading(false);
}

export async function fileTypeToggleHelper({
  type,
  fileTypeFilter,
  playlistFilter,
  setPlaylistFilter,
  sequenceFilter,
  setSequenceFilter,
  scheduleFilter,
  setScheduleFilter,
  assignmentFilter,
  setAssignmentFilter,
  tagFilter,
  setTagFilter,
  validationStatusTypeFilter,
  filterSearchField,
  importStatusTypeFilter,
  uploadedDateFilter,
  importedDateFilter,
  sortOrderFilter,
  sortColumnFilter,
  filesPerPage,
  setFileTypeFilter,
  setNoSearchResults,
  setFilesRetrieved,
  setTotalNumberOfRows,
  setFilterLoading,
  filterFiles,
  getLocalDateString,
  toggleFileType,
}) {
  setFilterLoading(true);

  const typeMap = {
    playlist: [playlistFilter, setPlaylistFilter],
    sequence: [sequenceFilter, setSequenceFilter],
    schedule: [scheduleFilter, setScheduleFilter],
    assignment: [assignmentFilter, setAssignmentFilter],
    tag: [tagFilter, setTagFilter],
  };
  let newFileTypes = [...fileTypeFilter];

  if (typeMap[type]) {
    newFileTypes = toggleFileType(
      type,
      typeMap[type][0],
      typeMap[type][1],
      fileTypeFilter,
      setFileTypeFilter,
    );
  }

  const { transformedData: _filesRetrieved, totalNumberOfRows: _totalNumberOfRows } =
    await filterFiles(
      newFileTypes,
      validationStatusTypeFilter,
      filterSearchField,
      importStatusTypeFilter,
      uploadedDateFilter ? getLocalDateString(uploadedDateFilter) : null,
      importedDateFilter ? getLocalDateString(importedDateFilter) : null,
      sortOrderFilter,
      sortColumnFilter,
      filesPerPage,
      1,
    );

  if (!_filesRetrieved || _filesRetrieved.length === 0) {
    setNoSearchResults(true);
    setFilterLoading(false);

    return;
  }

  setNoSearchResults(false);
  setFilesRetrieved(_filesRetrieved);
  setTotalNumberOfRows(_totalNumberOfRows);
  setFilterLoading(false);
}

export async function validationStatusFilterToggleHelper({
  type,
  validationStatusTypeFilter,
  validStatusFilter,
  setValidStatusFilter,
  invalidStatusFilter,
  setInvalidStatusFilter,
  setValidationStatusTypeFilter,
  fileTypeFilter,
  filterSearchField,
  importStatusTypeFilter,
  uploadedDateFilter,
  importedDateFilter,
  sortOrderFilter,
  sortColumnFilter,
  filesPerPage,
  setNoSearchResults,
  setFilesRetrieved,
  setTotalNumberOfRows,
  setFilterLoading,
  filterFiles,
  getLocalDateString,
}) {
  let newValidationStatus = [...validationStatusTypeFilter];

  setFilterLoading(true);

  if (type === 'valid') {
    if (validStatusFilter) {
      newValidationStatus = newValidationStatus.filter(el => el !== 'valid');
    } else {
      newValidationStatus.push('valid');
    }

    setValidationStatusTypeFilter([...newValidationStatus]);
    setValidStatusFilter(!validStatusFilter);
  }

  if (type === 'invalid') {
    if (invalidStatusFilter) {
      newValidationStatus = newValidationStatus.filter(el => el !== 'invalid');
    } else {
      newValidationStatus.push('invalid');
    }

    setValidationStatusTypeFilter([...newValidationStatus]);
    setInvalidStatusFilter(!invalidStatusFilter);
  }

  const { transformedData: _filesRetrieved, totalNumberOfRows: _totalNumberOfRows } =
    await filterFiles(
      fileTypeFilter,
      newValidationStatus,
      filterSearchField,
      importStatusTypeFilter,
      uploadedDateFilter ? getLocalDateString(uploadedDateFilter) : null,
      importedDateFilter ? getLocalDateString(importedDateFilter) : null,
      sortOrderFilter,
      sortColumnFilter,
      filesPerPage,
      1,
    );

  if (!_filesRetrieved || _filesRetrieved.length === 0) {
    setNoSearchResults(true);
    setFilterLoading(false);

    return;
  }

  setNoSearchResults(false);
  setFilesRetrieved(_filesRetrieved);
  setTotalNumberOfRows(_totalNumberOfRows);
  setFilterLoading(false);
}

export async function importStatusToggleHelper({
  type,
  importStatusTypeFilter,
  importedStatusFilter,
  setImportedStatusFilter,
  notImportedStatusFilter,
  setNotImportedStatusFilter,
  scheduledForImportStatusFilter,
  setScheduledForImportStatusFilter,
  setImportStatusTypeFilter,
  fileTypeFilter,
  validationStatusTypeFilter,
  filterSearchField,
  uploadedDateFilter,
  importedDateFilter,
  sortOrderFilter,
  sortColumnFilter,
  filesPerPage,
  setNoSearchResults,
  setFilesRetrieved,
  setTotalNumberOfRows,
  setFilterLoading,
  filterFiles,
  getLocalDateString,
}) {
  let newImportStatusFilterType = [...importStatusTypeFilter];

  setFilterLoading(true);

  if (type === 'imported') {
    if (importedStatusFilter) {
      newImportStatusFilterType = newImportStatusFilterType.filter(el => el !== 'imported');
    } else {
      newImportStatusFilterType.push('imported');
    }

    setImportStatusTypeFilter([...newImportStatusFilterType]);
    setImportedStatusFilter(!importedStatusFilter);
  }

  if (type === 'not_imported') {
    if (notImportedStatusFilter) {
      newImportStatusFilterType = newImportStatusFilterType.filter(el => el !== 'not_imported');
    } else {
      newImportStatusFilterType.push('not_imported');
    }

    setImportStatusTypeFilter([...newImportStatusFilterType]);
    setNotImportedStatusFilter(!notImportedStatusFilter);
  }

  if (type === 'scheduled_for_import') {
    if (scheduledForImportStatusFilter) {
      newImportStatusFilterType = newImportStatusFilterType.filter(
        el => el !== 'scheduled_for_import',
      );
    } else {
      newImportStatusFilterType.push('scheduled_for_import');
    }

    setImportStatusTypeFilter([...newImportStatusFilterType]);
    setScheduledForImportStatusFilter(!scheduledForImportStatusFilter);
  }

  const { transformedData: _filesRetrieved, totalNumberOfRows: _totalNumberOfRows } =
    await filterFiles(
      fileTypeFilter,
      validationStatusTypeFilter,
      filterSearchField,
      newImportStatusFilterType,
      uploadedDateFilter ? getLocalDateString(uploadedDateFilter) : null,
      importedDateFilter ? getLocalDateString(importedDateFilter) : null,
      sortOrderFilter,
      sortColumnFilter,
      filesPerPage,
      1,
    );

  if (!_filesRetrieved || _filesRetrieved.length === 0) {
    setNoSearchResults(true);
    setFilterLoading(false);

    return;
  }

  setFilterLoading(false);
  setNoSearchResults(false);
  setFilesRetrieved(_filesRetrieved);
  setTotalNumberOfRows(_totalNumberOfRows);
}

export async function filterSearchFieldChangeHelper({
  searchValue,
  fileTypeFilter,
  validationStatusTypeFilter,
  importStatusTypeFilter,
  uploadedDateFilter,
  importedDateFilter,
  sortOrderFilter,
  sortColumnFilter,
  filesPerPage,
  setFilterSearchField,
  setNoSearchResults,
  setFilesRetrieved,
  setTotalNumberOfRows,
  setFilterLoading,
  filterFiles,
  getLocalDateString,
}) {
  setFilterSearchField(searchValue);
  setFilterLoading(true);

  const { transformedData: _filesRetrieved, totalNumberOfRows: _totalNumberOfRows } =
    await filterFiles(
      fileTypeFilter,
      validationStatusTypeFilter,
      searchValue,
      importStatusTypeFilter,
      uploadedDateFilter ? getLocalDateString(uploadedDateFilter) : null,
      importedDateFilter ? getLocalDateString(importedDateFilter) : null,
      sortOrderFilter,
      sortColumnFilter,
      filesPerPage,
      1,
    );

  if (!_filesRetrieved || _filesRetrieved.length === 0) {
    setNoSearchResults(true);
    setFilterLoading(false);

    return;
  }

  setFilterLoading(false);
  setNoSearchResults(false);
  setFilesRetrieved(_filesRetrieved);
  setTotalNumberOfRows(_totalNumberOfRows);
}

export async function uploadedDateFilterHelper({
  newDate,
  fileTypeFilter,
  validationStatusTypeFilter,
  filterSearchField,
  importStatusTypeFilter,
  importedDateFilter,
  sortOrderFilter,
  sortColumnFilter,
  filesPerPage,
  setUploadedDateFilter,
  setNoSearchResults,
  setFilesRetrieved,
  setTotalNumberOfRows,
  setFilterLoading,
  filterFiles,
  getLocalDateString,
}) {
  setUploadedDateFilter(newDate);
  setFilterLoading(true);

  const formattedDate = getLocalDateString(newDate);
  const { transformedData: _filesRetrieved, totalNumberOfRows: _totalNumberOfRows } =
    await filterFiles(
      fileTypeFilter,
      validationStatusTypeFilter,
      filterSearchField,
      importStatusTypeFilter,
      formattedDate,
      importedDateFilter ? getLocalDateString(importedDateFilter) : null,
      sortOrderFilter,
      sortColumnFilter,
      filesPerPage,
      1,
    );

  if (!_filesRetrieved || _filesRetrieved.length === 0) {
    setNoSearchResults(true);
    setFilterLoading(false);

    return;
  }

  setNoSearchResults(false);
  setFilesRetrieved(_filesRetrieved);
  setTotalNumberOfRows(_totalNumberOfRows);
  setFilterLoading(false);
}

export async function importedDateFilterHelper({
  newDate,
  fileTypeFilter,
  validationStatusTypeFilter,
  filterSearchField,
  importStatusTypeFilter,
  uploadedDateFilter,
  sortOrderFilter,
  sortColumnFilter,
  filesPerPage,
  setImportedDateFilter,
  setNoSearchResults,
  setFilesRetrieved,
  setTotalNumberOfRows,
  setFilterLoading,
  filterFiles,
  getLocalDateString,
}) {
  setImportedDateFilter(newDate);
  setFilterLoading(true);

  const formattedDate = getLocalDateString(newDate);
  const { transformedData: _filesRetrieved, totalNumberOfRows: _totalNumberOfRows } =
    await filterFiles(
      fileTypeFilter,
      validationStatusTypeFilter,
      filterSearchField,
      importStatusTypeFilter,
      uploadedDateFilter ? getLocalDateString(uploadedDateFilter) : null,
      formattedDate,
      sortOrderFilter,
      sortColumnFilter,
      filesPerPage,
      1,
    );

  if (!_filesRetrieved || _filesRetrieved.length === 0) {
    setNoSearchResults(true);
    setFilterLoading(false);

    return;
  }

  setNoSearchResults(false);
  setFilesRetrieved(_filesRetrieved);
  setTotalNumberOfRows(_totalNumberOfRows);
  setFilterLoading(false);
}

export async function clearFiltersHelper({
  filesPerPage,
  setFilterLoading,
  setNoSearchResults,
  setImportedDateFilter,
  setUploadedDateFilter,
  setValidStatusFilter,
  setInvalidStatusFilter,
  setFilterSearchField,
  setPlaylistFilter,
  setScheduleFilter,
  setSequenceFilter,
  setAssignmentFilter,
  setTagFilter,
  setSortColumnFilter,
  setSortOrderFilter,
  setValidationStatusTypeFilter,
  setImportStatusTypeFilter,
  setImportedStatusFilter,
  setNotImportedStatusFilter,
  setScheduledForImportStatusFilter,
  setFileTypeFilter,
  setFilesRetrieved,
  setTotalNumberOfRows,
  handleFilterToggle,
  setErrorTitle,
  setErrorDescription,
  setShowError,
  fetchFiles,
}) {
  setFilterLoading(true);
  setNoSearchResults(false);
  setImportedDateFilter(null);
  setUploadedDateFilter(null);
  setValidStatusFilter(false);
  setInvalidStatusFilter(false);
  setFilterSearchField('');
  setPlaylistFilter(false);
  setScheduleFilter(false);
  setSequenceFilter(false);
  setAssignmentFilter(false);
  setTagFilter(false);
  setSortColumnFilter(null);
  setSortOrderFilter(null);
  setImportedStatusFilter(false);
  setNotImportedStatusFilter(false);
  setScheduledForImportStatusFilter(false);

  setValidationStatusTypeFilter([]);
  setImportStatusTypeFilter([]);
  setFileTypeFilter([]);

  const {
    success = false,
    transformedData: _filesRetrieved = [],
    totalNumberOfRows: _totalNumberOfRows = 0,
  } = await fetchFiles(filesPerPage, 1);

  if (success) {
    setFilesRetrieved(_filesRetrieved);
    setTotalNumberOfRows(_totalNumberOfRows);
    handleFilterToggle();
    setFilterLoading(false);
  } else {
    setFilterLoading(false);
    setErrorTitle('Something Went Wrong');
    setErrorDescription('Please refresh the page and try again');
    setShowError(true);
  }
}
